module.exports = __webpack_public_path__ + "media/images/about-us/Courses-8e34a08b30236743c49fc2dd566bc000.svg";